<!-- src/app/pages/customization/components/choose-sizes/choose-sizes.component.html -->
<div class="container my-5">
  <h3 class="main-title text-center">{{ 'CUSTOMIZATION.MATERIALS.TITLE' | translate }}</h3>

  <div class="row justify-content-center gy-4">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let part of parts">
      <div class="material-card-box p-4 h-100 d-flex flex-column justify-content-between">
        <div class="fw-semibold mb-2 text-center">{{ part.label | translate }}</div>

        <!-- Fabric type -->
        <select
          [id]="formatId(part.label)"
          class="form-select custom-select mb-3"
          [ngModel]="part.selectedFabricType"
          (ngModelChange)="chooseFabricType(part, $event)"
          [ngClass]="{ 'selected': part.selectedFabricType }"
        >
          <option value="" disabled hidden>
            {{ 'CUSTOMIZATION.MATERIALS.SELECT_FABRIC_TYPE' | translate }}
          </option>
          <option *ngFor="let type of fabricTypes" [value]="type">
            {{ type | translate }}
          </option>
        </select>

        <!-- Material picker -->
        <button
          [id]="formatId(part.label) + 'Button'"
          class="btn btn-outline-dark w-100"
          [ngClass]="{ 'selected': part.selectedMaterial }"
          [disabled]="!part.selectedFabricType"
          (click)="openMaterialModal(part)"
        >
          {{ part.selectedMaterial?.name || ('CUSTOMIZATION.MATERIALS.CHOOSE_MATERIAL' | translate) }}
        </button>

        <!-- Small helper line under the button -->
        <div class="small text-muted mt-2 text-center" *ngIf="part.selectedMaterial">
          {{ (part.selectedMaterial?.details ?? '') | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal (simple full-screen overlay) -->
<div class="modal-backdrop" *ngIf="activePart">
  <div class="material-modal">
    <h5 class="mb-3 text-center">
      {{ 'CUSTOMIZATION.MATERIALS.SELECT_FOR' | translate }}: {{ (activePart?.label ?? '') | translate }}
    </h5>

    <div class="row gy-4">
      <div class="col-6 col-sm-4 col-md-3" *ngFor="let mat of activePart.availableMaterials">
        <div
          [id]="formatId(mat.details)+'Card'"
          class="material-card text-center d-flex flex-column align-items-center"
          [class.selected]="mat === tempSelectedMaterial"
          (click)="selectMaterial(mat)"
        >
          <img [src]="mat.image" class="img-fluid mb-2 material-img" alt="material" />
          <div class="fw-bold mb-1">{{ mat.name | translate }}</div>
          <div class="small text-muted text-center">{{ mat.details | translate }}</div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4 gap-2">
      <button id="cancelButton" class="btn btn-outline-dark" (click)="cancelMaterial()">
        {{ 'CUSTOMIZATION.MATERIALS.CANCEL' | translate }}
      </button>
      <button id="confirmButton" class="btn btn-success" (click)="confirmMaterial()">
        {{ 'CUSTOMIZATION.MATERIALS.CONFIRM_SELECTION' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Sizes -->
<div class="container my-5">
  <h3 class="main-title text-center">{{ 'CUSTOMIZATION.SIZES.TITLE' | translate }}</h3>

  <div class="row justify-content-center gy-4">
    <div class="col-6 col-sm-4 col-md-3 col-lg-2" *ngFor="let size of sizes">
      <div class="size-card p-3 text-center h-100 d-flex flex-column justify-content-between">
        <div class="fw-semibold mb-2">{{ size.size | translate }}</div>

        <div class="quantity-controls mt-auto d-flex align-items-center justify-content-center">
          <button
            [id]="formatId(size.size) + 'SizeMinus'"
            class="btn btn-control"
            (click)="decrease(size)"
            [disabled]="size.count === 12"
            aria-label="decrease"
          >−</button>

          <div class="mx-2">{{ size.count }}</div>

          <button
            [id]="formatId(size.size) + 'SizePlus'"
            class="btn btn-control"
            (click)="increase(size)"
            aria-label="increase"
          >+</button>
        </div>
      </div>
    </div>
  </div>
</div>
